/**
 * Convert the Metadata (which is an alias) to latest
 * @internal
 **/
export function toLatest(_registry, v15, _metaVersion) {
    return v15;
}
